/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormField, FormItem, FormLabel, FormDescription, FormMessage } from "@/shared/components/ui/form"
import { Input } from "@/shared/components/ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/shared/components/ui/select"
import { useTranslation } from "react-i18next"
import { Control } from "react-hook-form"

interface ArrayFieldItemFormProps {
  field: any
  index: number
  baseKey: string
  control: Control<any>
}

export function ArrayFieldItemForm({ field, index, baseKey, control }: ArrayFieldItemFormProps) {
  const { t: _t } = useTranslation()

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 pt-2">
      {field.items.fields.map((subField: any) => (
        <FormField
          key={`${baseKey}.${index}.${subField.name}`}
          control={control}
          name={`${baseKey}.${index}.${subField.name}`}
          render={({ field: subFormField }) => (
            <FormItem>
              <FormLabel className="text-sm">{subField.label}</FormLabel>
              {subField.type === 'select' ? (
                <Select
                  value={(() => {
                    const raw = subFormField.value;
                    const isPrimitive = typeof raw === 'string' || typeof raw === 'number';
                    if (raw === '' || raw === null || raw === undefined || !isPrimitive) {
                      return undefined;
                    }
                    return String(raw);
                  })()}
                  onValueChange={(val) => subFormField.onChange(val)}
                >
                  <SelectTrigger className="h-9">
                    <SelectValue placeholder={""} />
                  </SelectTrigger>
                  <SelectContent>
                    {subField.options.map((option: string) => (
                      <SelectItem key={option} value={option}>
                        {option}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              ) : (
                <Input
                  {...subFormField}
                  type={subField.type === 'number' ? 'number' : 'text'}
                  placeholder={subField.placeholder}
                  className="h-9"
                />
              )}
              {subField.description && (
                <FormDescription className="text-xs">{subField.description}</FormDescription>
              )}
              <FormMessage />
            </FormItem>
          )}
        />
      ))}
    </div>
  )
}
